import { DefaultChatTransport, isTextUIPart } from "ai";
import { getSharedAuthHeaders, getSharedBaseUrl } from "@rebuild/shared";
import type { EstimateChatMessage } from "@rebuild/shared/models";
import type { EstimateChatRequestBody, EstimateChatUIMessage } from "./estimateChatStream.types";

export function getMessageText(message: EstimateChatUIMessage): string {
  return message.parts
    .filter(isTextUIPart)
    .map((part) => part.text)
    .join("");
}

/* useChat transport to customize requests to our api endpoints: specifiy trigger (regen or regular user message)
* */
export const estimateChatTransport = new DefaultChatTransport<EstimateChatUIMessage>({
  headers: getSharedAuthHeaders,
  prepareSendMessagesRequest: ({ messages, trigger, body }) => {
    const { estimateId, chatId } = body as EstimateChatRequestBody;
    const userMessage = messages[messages.length - 1];
    return {
      api: `${getSharedBaseUrl()}/rest/estimates/${estimateId}/chats/${chatId}/messages`,
      body: { messageId: userMessage.id, content: getMessageText(userMessage), trigger },
    };
  },
});

// Replaces messages already cached under the same id (the user message may be there from a refetch),
// then appends the rest.
export function mergeSavedMessages(cached: EstimateChatMessage[], saved: EstimateChatMessage[]): EstimateChatMessage[] {
  const savedIds = new Set(saved.map((m) => m.id));
  return [...cached.filter((m) => !savedIds.has(m.id)), ...saved];
}

// Errors before the stream opens arrive as the server's JSON error body; stream errors are plain text.
export function toChatErrorMessage(error: Error): string {
  try {
    const parsed: unknown = JSON.parse(error.message);
    if (parsed && typeof parsed === "object" && "message" in parsed && typeof parsed.message === "string") {
      return parsed.message;
    }
  } catch {
    // not JSON
  }
  return error.message;
}
